import {post,fetch,patch,put} from './http'

export function appMenu(params = {}) {
  return fetch('/app/menu', params)
}

export function bannerList(params = {}) {
  return fetch('/app/bannerList', params)
}

export function indexDataList(params) {
  return fetch('/app/indexDataList', params)
}

export function itemList(params = {}) {
  return fetch('/app/itemList', params)
}
export function getAppInfo(key) {
  return fetch('/app/info', {key})
}

export function productCategoryDetail(productCategoryId) {
  return fetch('/product/productCategoryDetail', {productCategoryId})
}
export function productDetail(productId) {
  return fetch('/product/productDetail', {productId})
}
export function getProductList(params) {
  return fetch('/product/productList', params)
}

export function functionPage(params) {
  return fetch('/product/functionPage', params)
}


export function businessDetail(businessId) {
  return fetch('/business/detail', {businessId})
}

export function advantageIconList(params) {
  return fetch('/app/advantageIconList', params)
}

export function imgList(params) {
  return fetch('/app/imgList', params)
}

// 新闻列表
export function casePage(params) {
  return fetch('/app/casePage', params)
}
export function caseDetail(caseId) {
  return fetch('/app/caseDetail', {caseId})
}
// 公司介绍项目列表
export function companyItemList(params) {
  return fetch('/app/companyItemList', params)
}


export function commitMessage(params) {
  return post('/app/commitMessage', params)
}










// WEBPACK FOOTER //
// ./src/utils/api.js